module.exports = __webpack_public_path__ + "static/media/crssoft_deloitte.1bacbc08.png";